export default __webpack_public_path__ + "media/images/work_with_us/team-pic-3-b3f8695c1b112b13eff9bbc3e696380e.webp";